import React from 'react';
import Header from '../../components/Header';
import LinkList from '../../components/LinkList';

const TermsOfService = ({handleLogoutClick}) => {
  const links = [{
    to: '/help',
    text: 'Help'
  }, {
    to: '/privacy-policy',
    text: 'Privacy Policy'
  }];
  
  return(
    <div>
      <Header
        handleLogout={handleLogoutClick}
        title="TERMS OF SERVICE" />
      <LinkList linkItems={links}/>
    </div>
  );
}

export default TermsOfService;



/** WEBPACK FOOTER **
 ** ./src/containers/TermsOfService/index.js
 **/